import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import WorkOrderEditForm from '../work_order_edit_form/WorkOrderEditForm';
import { workOrdersRestCrudThunksForBuyer } from '../../thunks/work_orders_thunks';
import { EditPage } from '../edit_page/EditPage';
import { PageLoadingPlaceholder } from '../page_loading_placeholder/PageLoadingPlaceholder';
import { goBackLink, recursiveRemovePreserve } from '../../utils/HistoryUtils';
import { getWorkOrderSelector } from '../../selectors/workOrderSelectors';
import { getEntityById } from '../../utils/DataAccessUtils';

const style = require('./EditWorkOrderPage.less');
const queryString = require('qs');

class EditWorkOrderPage extends React.Component<any, any> {
	constructor(props) {
		super(props);
		this.state = {
			fetching: true,
		};
	}

	componentDidMount() {
		const { getWorkOrder, match, location } = this.props;
		const workOrderId = match.params.id;
		getWorkOrder(workOrderId).then(() => {
			this.setState({ fetching: false });
		});
	}

	render() {
		const { history, workOrder, location } = this.props;
		const { fetching } = this.state;
		const defaultUrlPath = `/buyer/workOrders/detail/${workOrder.id}/details`;

		return fetching ? (
			<PageLoadingPlaceholder />
		) : (
			<EditPage
				title="Edit Work Order"
				formComponentProps={{
					formData: workOrder,
					isApprovalForm: false,
					onSuccess: (rec) => {
						let string = goBackLink(location, defaultUrlPath);
						const [path, queryParams] = string.split('?');
						let urlSearchParams = queryString.parse(queryParams);
						history.push(`${path}?${recursiveRemovePreserve(urlSearchParams)}`);
					},
				}}
				fetching={fetching}
				FormComponent={WorkOrderEditForm}
			/>
		);
	}
}

const mapStateToProps = (state, ownProps) => {
	return {
		history: ownProps.history,
		workOrder: getEntityById(ownProps.match.params.id, state.work_orders),
		match: ownProps.match,
	};
};

const mapDispatchToProps = (dispatch) => ({
	getWorkOrder: (id) => dispatch(workOrdersRestCrudThunksForBuyer.readOne(id)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EditWorkOrderPage));
